<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/hotels/create"
      >{{ $t("customers.hotels.new") }}</v-btn
    >
    <DataTable
      :url="api.ACTIONS.PASSENGERS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at', 'billing_email', 'address', 'phone_number']"
      :fields-hidden-add="['id', 'deleted_at', 'created_at', 'updated_at', 'address']"
      :input-types-add="{
        password: 'password',
        password_confirmation: 'password',
      }"
      :formatter="formatters"
      :title="$t('customers.hotels.tableTitle')"
      :enableEdit="false"
      :enableAdd="false"
      :add-rules="rules"
      :initial-url-search-params="par"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";

const required = (val) =>
  (val !== null && val !== undefined) || i18n.t("customers.hotels.requiredField");
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  i18n.t("customers.hotels.validEmail");
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) ||
  i18n.t("customers.hotels.pastDate");

export default {
  name: "Hotels",
  title() {
    return this.$t("customers.hotels.title");
  },
  components: { DataTable },
  data() {
    return {
      accommodation: "hotel",
      formatters: {
        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
      },
    };
  },

  computed: {
    rules() {
      return {
        username: [required],
        password: [required],
      };
    },
    par() {
      const par = new URLSearchParams();
      par.append("type", this.accommodation);
      return par;
    },
    titles() {
      return {
        id: this.$t("customers.hotels.number"),
        username: this.$t("customers.hotels.email"),
        username: this.$t("customers.hotels.userName"),
        full_name: this.$t("customers.hotels.hotelName"),
        phone: this.$t("customers.hotels.phoneNumber"),
        created_at: this.$t("customers.hotels.creationDate"),
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("customers.hotels.profile"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "PassengerProfile",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
